module.exports = __webpack_public_path__ + "static/img/service-1.cfea8e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/service-1.png
// module id = Mfyj
// module chunks = 1